import lockZoneData from "./partOne/lockZoneData"

const puzzleAnswerData = [
    {},
    {
        correctKey: "553",
        zoneOne: lockZoneData[5],
        zoneTwo: lockZoneData[0], 
    },
    {},
    {
        deskCode: "32131",
        safeCode: " 7 2 6 3"
    },
    {
        correctFormula: "b2a4srcah2k2"
    },
    {
        accusation: "Tara Smythe 953284",
        mapCode: {
            hideoutOne: "b5",
            hideoutTwo: "c1",
            hideoutThree: "a6"
        },
        switchCode: "1101010011",
        briefcaseCode: "142352"
    }   
]

export default puzzleAnswerData